import type MarketStats from 'app/shared/models/MarketStats';

export function isEmpty(marketStats: MarketStats): boolean {
    return !marketStats.medianRent && !marketStats.curYearRentPrices.length && !marketStats.prevYearRentPrices.length;
}
